'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Illustration, IllustrationWrapper } from '@components/Common';
import { OnboardingStep } from '@components/Onboarding/TeacherOnboarding/components';
import { ImageContainer } from '@components/Onboarding/TeacherOnboarding/styles';

export const PhotoStep: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <OnboardingStep
      stepLabel={t('onboardingTeacher.stepOne')}
      title={t('onboardingTeacher.setPhoto')}
      description={t('onboardingTeacher.stepOneDescription')}>
      <ImageContainer>
        <IllustrationWrapper>
          <Illustration
            priority
            fill
            src={'/assets/images/Illustration-photo.svg'}
            alt={t('onboardingTeacher.setPhoto')}
          />
        </IllustrationWrapper>
      </ImageContainer>
    </OnboardingStep>
  );
};
